import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const GoogleDevice11: FC<Props> = (props) => (
  <Root viewBox="0 0 145.783 300.88" {...props}>
    <g data-name="\u30B0\u30EB\u30FC\u30D7 318" transform="translate(-599.892 -156.533)">
      <rect
        data-name="\u9577\u65B9\u5F62 750"
        width={145.783}
        height={300.88}
        rx={21.724}
        transform="translate(599.892 156.533)"
      />
      <path data-name="\u9577\u65B9\u5F62 751" fill="#fff" d="M606.172 196.186h132.072v21.956H606.172z" />
      <g data-name="\u30B0\u30EB\u30FC\u30D7 317">
        <path
          data-name="\u30D1\u30B9 1023"
          d="M738.163 196.186v-18.01a14.309 14.309 0 00-14.309-14.309h-14.122v1.918a7.586 7.586 0 01-7.586 7.586h-59.117a7.586 7.586 0 01-7.586-7.586v-1.918h-14.962a14.309 14.309 0 00-14.309 14.309v18.01z"
          fill="#f2f2f2"
        />
      </g>
      <rect
        data-name="\u9577\u65B9\u5F62 752"
        width={116.48}
        height={11.384}
        rx={5.692}
        transform="translate(612.206 179.958)"
        fill="#e7e7e7"
      />
      <path data-name="\u9577\u65B9\u5F62 753" fill="#eee" d="M611.546 201.494h34.371v3.938h-34.371z" />
      <path data-name="\u9577\u65B9\u5F62 754" fill="#eee" d="M720.774 207.85h12.478v3.938h-12.478z" />
      <path data-name="\u9577\u65B9\u5F62 755" fill="#eee" d="M611.546 207.58h55.231v4.208h-55.231z" />
      <path
        data-name="\u30D1\u30B9 1024"
        d="M606.172 346.435v89.337a14.309 14.309 0 0014.309 14.309h103.373a14.309 14.309 0 0014.309-14.309v-89.337z"
        fill="#fff"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 756"
        width={34.733}
        height={3.524}
        rx={1.762}
        transform="translate(653.597 442.557)"
      />
      <path data-name="\u9577\u65B9\u5F62 757" fill="#424242" d="M606.1 217.498h132.077v132.077H606.1z" />
      <path data-name="\u9577\u65B9\u5F62 758" fill="#eee" d="M611.546 384.59h8.628v3.938h-8.628z" />
      <path data-name="\u9577\u65B9\u5F62 759" fill="#eee" d="M611.546 354.633h122.615v4.208H611.546z" />
      <path data-name="\u9577\u65B9\u5F62 760" fill="#eee" d="M611.546 374.834h122.615v4.208H611.546z" />
      <path data-name="\u9577\u65B9\u5F62 761" fill="#eee" d="M611.546 364.189h117.908v4.208H611.546z" />
      <path data-name="\u9577\u65B9\u5F62 762" fill="#eee" d="M611.546 397.506h122.615v4.208H611.546z" />
      <path data-name="\u9577\u65B9\u5F62 763" fill="#eee" d="M611.546 407.063h66.11v4.208h-66.11z" />
      <path data-name="\u7DDA 3" fill="none" stroke="#f5f5f5" strokeMiterlimit={10} d="M606.348 417.544h131.654" />
      <circle
        data-name="\u6955\u5186\u5F62 457"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(724.434 423.977)"
        fill="#2d81ff"
      />
      <circle
        data-name="\u6955\u5186\u5F62 458"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(687.551 423.977)"
        fill="#2d81ff"
      />
      <circle
        data-name="\u6955\u5186\u5F62 459"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(648.931 423.977)"
        fill="#2d81ff"
      />
      <circle
        data-name="\u6955\u5186\u5F62 460"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(612.048 423.977)"
        fill="#2d81ff"
      />
    </g>
  </Root>
);

const Root = styled('svg')();

export default GoogleDevice11;
